import { Suspense, useEffect } from "react";
import { FloatButton } from "antd";
import ErrorBoundary from "./ErrorBoundary";
import { useStores } from "hooks/useStores";
import { AppRouter } from "./AppRouter";
import { AppCacheConfig } from "./AppCacheConfig";

export default function App() {
    const { userStore } = useStores();

    useEffect(() => {
        userStore.fetchUser();
    }, [userStore]);

    return (
        <AppCacheConfig>
            <Suspense fallback='' /*Suspense for i18n*/>
                <ErrorBoundary>
                    <AppRouter />
                    <FloatButton.BackTop />
                </ErrorBoundary>
            </Suspense>
        </AppCacheConfig>
    );
}
